import React, {useMemo, useState} from 'react';
import {Table, Tag} from 'antd';
import TablePage from "../../../pages/tablePage/TablePage";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import {useTrophyChallengeMissionGroup} from "./useTrophyChallenge";
import TrophyChallengeMissionGroupEditModal from "./TrophyChallengeMissionGroupEditModal";
import {TrophyChallengeMissionGroupEntity} from "./TrophyChallengeMissionGroupEntity";

const TrophyChallengeMissionManager = () => {
    const [rowData, setRowData] = useState(null);
    const {data, isLoading, error} = useTrophyChallengeMissionGroup();
    const groupedData = useMemo(() => {
        if (!data) return [];
        const groups = {};
        data.forEach(row => {
            if (!groups[row.groupIdx]) {
                groups[row.groupIdx] = {
                    groupIdx: row.groupIdx,
                    tableIdx: row.tableIdx,
                    memo: row.memo,
                    isFixed: row.isFixed,
                    items: [],
                    key: row.groupIdx,
                };
            }
            groups[row.groupIdx].items.push(row);
        });
        return Object.values(groups).sort((a, b) => a.groupIdx - b.groupIdx);
    }, [data]);

    const columns = useMemo(() => ([
        {
            title: '그룹 번호',
            dataIndex: 'groupIdx',
            key: 'groupIdx',
            width: 110,
            sorter: (a, b) => a.groupIdx - b.groupIdx,
            search: true,
        },
        {
            title: '테이블 그룹',
            dataIndex: 'tableIdx',
            key: 'tableIdx',
            width: 90,
        },
        {
            title: '메모',
            key: 'memo',
            render: (_, record) => record.memo || '-',
        },
        {
            title: '미션 수',
            key: 'count',
            width: 90,
            render: (_, record) => record.items?.length || 0,
        },
        {
            title: '고정 여부',
            key: 'isFixed',
            width: 90,
            render: (_, record) => record.isFixed ? <Tag color="red">확정</Tag> : <Tag>미확정</Tag>,
        },
    ]), []);

    const expandedRowRender = useMemo(() => (record) => {
        const itemCols = [
            {title: '순서', dataIndex: 'groupSeq', key: 'groupSeq', width: 70},
            {title: '미션명', dataIndex: 'name', key: 'name', width: 140},
            {title: '설명', dataIndex: 'subName', key: 'subName', width: 140},
            {title: 'conditionIdx', dataIndex: 'conditionIdx', key: 'conditionIdx', width: 110},
            {title: 'conditionType', dataIndex: 'conditionType', key: 'conditionType', width: 130},
            {title: 'conditionValue', dataIndex: 'conditionValue', key: 'conditionValue', width: 120},
            {title: 'conditionCount', dataIndex: 'conditionCount', key: 'conditionCount', width: 120},
            {title: 'shortCutType', dataIndex: 'shortCutType', key: 'shortCutType', width: 110},
            {title: 'trophyImg', dataIndex: 'trophyImg', key: 'trophyImg', width: 100},
            {title: 'rewardIdx1', dataIndex: 'rewardIdx1', key: 'rewardIdx1', width: 100},
            {title: 'rewardIdx2', dataIndex: 'rewardIdx2', key: 'rewardIdx2', width: 100},
            {title: 'rewardIdx3', dataIndex: 'rewardIdx3', key: 'rewardIdx3', width: 100},
        ];

        return (
            <Table
                columns={itemCols}
                dataSource={record.items.map((it, i) => ({...it, key: i}))}
                pagination={false}
                size="small"
                scroll={{x: 'max-content'}}
            />
        );
    }, []);

    if (isLoading) return <IsLoading/>;
    if (error) return <ErrorPage error={error}/>;

    const props = {
        columns,
        localData: groupedData,
        modal: TrophyChallengeMissionGroupEditModal,
        buttonText: '챌린지 미션 그룹 추가',
        rowData,
        setRowData,
        entityModel: TrophyChallengeMissionGroupEntity,
        expandedRowRender,
        modalOptions: {allRows: data || []},
        modalWidth: 1000,
        modalResizable: true,
    };

    return <TablePage {...props}/>;
};

export default TrophyChallengeMissionManager;
